import React from 'react'

import styled from 'styled-components';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import SectionItem from './SectionItem';
import 'swiper/css';
import 'swiper/css/pagination';

export default function SectionMobile({title, pieces: items}) {
  return (
    <SECTION>
      <h2>{title}</h2>
        <Swiper
          modules={[Pagination]}
          slidesPerView={1}
          pagination={{ clickable: true }}
          loop={true}
          lazy={true}
          lazyPreloadPrevNext={1}
          nested={true}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <SectionItem
                title={item.title}
                authors={item.authors}
                pieceId={item.id}
                image_path={item.image_path}
              />
            </SwiperSlide>
          ))}
        </Swiper>
    </SECTION>
  )
}

const SECTION = styled.section`
  margin: 0 20px;

  & h2 {
    text-align: center;
    margin-bottom: 1.25rem;
    font-size: 1.125rem;
    font-weight: 500;
    font-family: var(--primary-font);
  }

  & .swiper-pagination {
    --swiper-pagination-bullet-horizontal-gap: 8px;
  }
  & .swiper-pagination-bullet {
    border: 1px solid var(--swiper-color);
    width: 20px;
    height: 20px;
    opacity: 1;
    background-color: transparent;
  }
  & .swiper-pagination-bullet-active {
    background-color: var(--swiper-color);
  }

  & .swiper-slide {
    margin-bottom: 90px;
  }
`;
